import React from "react";
import "./footer.css";

const Footer = () => {
  return (
    <footer className="bg-black text-white py-10 px-6 md:px-16 grid grid-cols-1 md:grid-cols-3 gap-10 items-start">
      
      {/* Left Side: Social Media & Logo */}
      <div className="flex flex-col items-center md:items-start space-y-6">
        {/* Social Media Icons */}
        <div className="social-media">
          <a href="https://www.facebook.com/Smaaashlivee/" target="_blank" rel="noopener noreferrer">
            <img src="/icons/facebook.png" alt="Facebook" className="w-8 h-8" />
          </a>
          <a href="https://www.instagram.com/esmaaash/" target="_blank" rel="noopener noreferrer">
            <img src="/icons/instagram.png" alt="Instagram" className="w-8 h-8" />
          </a>
          <a href="https://www.youtube.com/@eSmaaash" target="_blank" rel="noopener noreferrer">
            <img src="/icons/youtube.png" alt="YouTube" className="w-8 h-8" />
          </a>
          <a href="https://discord.gg/AHjG2vnvjw " target="_blank" rel="noopener noreferrer">
            <img src="/icons/discord.png" alt="YouTube" className="w-8 h-8" />
          </a>
        </div>

        {/* Logo */}
        <div className="mt-6">
         <div className="footer-logo">
          <img src="/LOGO ESMAAASH Black.png" alt="Esmaaash Logo" className="w-36" />
          </div>
        </div>
      </div>
{/* Right Side: Quick Links & Rules */}
<div className="flex flex-col md:items-end space-y-6">
        {/* Quick Links */}
        <div className="Quick-Links">
          <p className="font-semibold">Quick Links</p>
          <a href="/" className="hover:underline block text-white hover:text-yellow-400">Home</a>
<a href="/Events" className="hover:underline block text-white hover:text-yellow-400">Events</a>
<a href="/Ambassadorclub" className="hover:underline block text-white hover:text-yellow-400">Ambassador Club</a>

        </div>

     <div className="Rules">
            <p className="font-semibold">Rules &amp; Regulations</p>
  <a href="/PrivacyPolicy" className="hover:underline block">Privacy Policy</a>
  <a href="/RefundPolicy" className="hover:underline block">Refund Policy</a>
  <a href="/TermsConditions" className="hover:underline block">Terms &amp; Conditions</a>
</div>


        
      </div>
      {/* Center: Address & Contact */}
      <div className="address">
      <div className="address text-center space-y-4">
  <p className="font-bold text-lg">
    SMAAASH ENTERTAINMENT PVT. LTD.
  </p>
  <p>
    Metro Avenue G-2 Ground Floor, Andheri-Kurla Road, 
    Next to WEH Metro Station, Chakala, Andheri (East), 
    Mumbai - 400093.
  </p>
  <p>
    +91 9930332525 &nbsp; | &nbsp; 
    <br /> esmaaash@smaaash-entertainment.in
  </p>

  <p>
    This website uses cookies to ensure you get the best experience.{" "}
    <a 
      href="/CookiesPolicy" 
      className="text-blue-400 hover:text-blue-600 font-semibold underline"
    >
      Read our Cookies Policy
    </a>
  </p>

  <p className="rights">
    &copy; {new Date().getFullYear()} Esmaaash. All rights reserved.
  </p>
</div>

      </div>
      

    </footer>
  );
};

export default Footer;
